const trainingMenuItems = [
  {
    to: '/training/web-designing-course-modasa/',
    label: 'Web Designing Course in Modasa',
  },
  {
    to: '/training/web-development-course-modasa/',
    label: 'Web Development Course in Modasa',
  },
  {
    to: '/training/digital-marketing-course-modasa/',
    label: 'Digital Marketing Course in Modasa',
  },
  {
    to: '/training/bca-internship-industrial-project-guidance/',
    label: 'BCA Internship & Industrial Project Guidance',
  },
  {
    to: '/training/industry-project-internship-mentorship/',
    label: 'Industry Project, Internship & Mentorship',
  },
  {
    to: '/training/internship-project-guidance-modasa/',
    label: 'Internship & Project Guidance (Modasa)',
  },
  {
    to: '/training/btech-be-internship-project-guidance/',
    label: 'BTech / BE Internship Project Guidance',
  },
];

export default trainingMenuItems;
